import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import './index.css';
import './styles/theme.css';
import './i18n';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
// Dev trace helper
if (process.env.NODE_ENV !== 'production') {
  try {
    // eslint-disable-next-line global-require
    const { installClientTrace } = require('./utils/trace');
    installClientTrace();
    // eslint-disable-next-line no-console
    console.debug('[TRACE] installed');
    // Disable CRA dev-server liveReload/overlay induced reloads by telling our early script to swallow reloads
    window.__BLOCK_WDS_RELOAD__ = true;
    if ('serviceWorker' in navigator) {
      // Dev ortamında mevcut SW'leri kaldır ve cache'i temizle
      navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
      if (window.caches && caches.keys) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
      }
    }
  } catch (_) {}
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
); 

// Register service worker only in production over HTTPS (HTTP + ham IP'de SW cache beyaz ekrana yol acar)
if (
  process.env.NODE_ENV === 'production' &&
  'serviceWorker' in navigator &&
  window.location.protocol === 'https:'
) {
  window.addEventListener('load', async () => {
    try {
      await navigator.serviceWorker.register('/sw.js');
      navigator.serviceWorker.addEventListener('message', (event) => {
        const data = event.data || {};
        if (data.type === 'notification_click' && data.url) {
          const target = data.url.startsWith('/') ? data.url : '/' + data.url;
          window.focus();
          window.history.pushState({}, '', target);
          window.dispatchEvent(new PopStateEvent('popstate'));
        }
      });
    } catch (err) {
      console.warn('SW registration failed:', err.message);
    }
  });
} else {
  // eslint-disable-next-line no-console
  console.debug('[TRACE] service worker disabled in development');
}